module.exports = __webpack_public_path__ + "ch.a3312ec4e447949e5f95.svg";


//////////////////
// WEBPACK FOOTER
// /Users/andrescufari/Angular/lednube/theme/scss/icons/flag-icon-css/flags/ch.svg
// module id = ../../../../../theme/scss/icons/flag-icon-css/flags/ch.svg
// module chunks = styles